import React, { useContext, useRef } from 'react';
import DataGrid, { Button as GridButton, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup, HeaderFilter } from "devextreme-react/data-grid";
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling } from '../../utils/errorHandling';
import TenantContext from '../../contexts/tenantContext';
import { useAssistitiDataSource } from '../../datasources/AssistitiDataSource';
import AssistitoEditPopup, { AssistitoEditPopupHandle } from '../../components/assistitoEdit/AssistitoEditPopup';
import { ColumnButtonClickEvent } from 'devextreme/ui/data_grid';
import PopupSendInvite, { SendInvitePopupHandle } from '../../components/popupSendInvite/popupSendInvite';


export default function Assistiti() {
  const gridRef = useRef<DataGridRef>(null);
  const dataSource = useAssistitiDataSource();
  const assistitoEditPopupRef = useRef<AssistitoEditPopupHandle>(null);
    const sendInviteRef = useRef<SendInvitePopupHandle>(null);

  function openAssistitoEditPopup(e: any) {
    assistitoEditPopupRef.current?.show(e.row.key, `${e.row.data.nome} ${e.row.data.cognome}`);
  }
  const refreshGrid = () => { gridRef.current?.instance().refresh(); }

  const grid_RowInserted = (e:any) => { assistitoEditPopupRef.current?.show(e.key, `${e.data.nome} ${e.data.cognome}`); }

  function SendInvite_click(e:ColumnButtonClickEvent){
    sendInviteRef.current?.inviteAssistito(e.row?.key);
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Assistiti</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          <DataGrid
            dataSource={dataSource}
            ref={gridRef}
            onDataErrorOccurred={dataGridErrorHandling}
            onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
            onRowInserted={grid_RowInserted}
          >
            <Editing
              mode="popup"
              allowUpdating={true}
              allowAdding={true}
              allowDeleting={true}>
              <Popup title="Assistito" showTitle={true} maxHeight={200} maxWidth={600} />
              <Form colCount={2}>
                <Item dataField="nome" editorType='dxTextBox' isRequired={true} />
                <Item dataField="cognome" editorType='dxTextBox' isRequired={true} />
              </Form>
            </Editing>
             <HeaderFilter visible={true} allowSearch={true} />
            <Column type='buttons' alignment='left'>
              <GridButton name="edit" onClick={openAssistitoEditPopup} />
              <GridButton name="delete" />
              <GridButton 
                          icon='send'
                          hint='Invia invito a partecipare alla piattaforma'
                          onClick={SendInvite_click}
                          visible={(e)=> e.row.data.email }
                          disabled={(e)=> e.row.data.hasUserId } />
            </Column>
            <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
            <Column dataField={'nome'} caption={'Nome'} />
            <Column dataField={'cognome'} caption={'Cognome'} />
            <Column dataField={'codiceFiscale'} caption={'Codice fiscale'} hidingPriority={12} />
            <Column dataField={'dataDiNascita'} caption={'Data di nascita'} dataType='date' hidingPriority={13} />
            <Column dataField={'sesso'} visible={false} hidingPriority={14} />
            <Column dataField={'nascitaNazione'} visible={false} hidingPriority={5} />
            <Column dataField={'nascitaRegione'} visible={false} hidingPriority={4} />
            <Column dataField={'nascitaProvincia'} visible={false} hidingPriority={3} />
            <Column dataField={'nascitaComune'} visible={false} hidingPriority={2} />
            <Column dataField={'residenzaNazione'} visible={false} hidingPriority={6} />
            <Column dataField={'residenzaRegione'} visible={false} hidingPriority={7} />
            <Column dataField={'residenzaProvincia'} visible={false} hidingPriority={8} />
            <Column dataField={'residenzaComune'} visible={false} hidingPriority={9} />
            <Column dataField={'residenzaIndirizzo'} visible={false} hidingPriority={11} />
            <Column dataField={'residenzaNumeroCivico'} visible={false} hidingPriority={10} />
            <Column dataField={'email'} hidingPriority={15} />
            <Column dataField={'telefono'} hidingPriority={16} />
            <Column dataField={'cellulare'} hidingPriority={17} />
            <Column dataField={'note'} hidingPriority={1} />
          </DataGrid>

          <AssistitoEditPopup ref={assistitoEditPopupRef} onHidden={refreshGrid} />
        </div>
      </div>

            <PopupSendInvite ref={sendInviteRef} />
    </React.Fragment>
  )
}
